import { navContentStore } from "@phn/state/nav-content-store";
import { Component, EventEmitter, Fragment, h, JSX, Prop } from "@stencil/core";
import { getMenuContent } from "@phn/services/menu-items-service";
import {
  filterWishlistItemsByAuthStatus,
  getAvailableShopVariables,
  getIconNameByMenuItemId,
} from "@phn/utility/helper/shop-helper";
import { replaceVariables } from "@phn/utility/helper/string-helper";
import { Timeout } from "@phn/utility/timeout";
import windowService from "@phn/services/window-service";
import {
  constructRoutingKey,
  RoutingKeys,
} from "../../../../../shared/entities/routing-key";
import { EventActions } from "../../../../../shared/utility/constants";
import {
  TShopAuthStatus,
  TShopMenu,
} from "../../../../../shared/entities/content";
import { navStateStore } from "../../../../../shared/state/nav-state-store";
import {
  isDesktop,
  IsLoggedIn,
  isString,
} from "../../../../../shared/utility/helper";

@Component({
  tag: "phn-nd-shop-section",
})
export class ShopSection {
  @Prop() activeRoutingKey;

  @Prop() breakpoint;

  @Prop() receivedContent;

  @Prop() phnLogin!: EventEmitter<void>;

  @Prop() showWishlist: boolean;

  private eventPreventedTimeout = new Timeout(0);

  handleLogin(id: string) {
    if (id === "login") {
      const phnLogin = this.phnLogin.emit();

      this.eventPreventedTimeout.set(() => {
        if (phnLogin.defaultPrevented) {
          return;
        }

        const loginLink = navContentStore.state.myPorsche?.link;
        if (isString(loginLink)) {
          windowService.redirectToUrl(loginLink);
          return;
        }
      });
    }
  }

  render(): JSX.Element {
    const showHeadline = !isDesktop(this.breakpoint);
    const displayedContent = getMenuContent(
      navContentStore.state,
      this.activeRoutingKey,
      RoutingKeys.SHOP,
    ) as TShopMenu;

    if (displayedContent === null) {
      return <div></div>;
    }

    const wishListAuthStatusList: TShopAuthStatus[] = IsLoggedIn(
      navStateStore.state.loggedInState,
    )
      ? ["loggedIn", null]
      : ["loggedOut", null];

    const wishListItems = filterWishlistItemsByAuthStatus(
      displayedContent.additionalContent,
      wishListAuthStatusList,
    );

    return (
      <Fragment>
        <phn-nd-menu
          item={displayedContent}
          showHeadline={showHeadline}
          receivedContent={this.receivedContent}
        />
        {this.activeRoutingKey === RoutingKeys.SHOP && this.showWishlist ? (
          <div class="wishlist-container" role="list">
            {wishListItems.map((childItem) => (
              <phn-nd-menu-item
                key={childItem.id}
                data-id={childItem.id}
                size={"x-small"}
                class={
                  !(isString(childItem.iconUrl) || isString(childItem.icon))
                    ? "no-icon"
                    : ""
                }
                iconLeft={
                  (isString(childItem.id) &&
                    getIconNameByMenuItemId(childItem.id)) ||
                  childItem.icon ||
                  childItem.iconUrl
                }
                elementId={constructRoutingKey(
                  this.activeRoutingKey,
                  childItem.id,
                )}
                analyticsId={childItem.id}
                text={replaceVariables(
                  childItem.text,
                  getAvailableShopVariables(),
                )}
                link={childItem.link}
                datalayerEventAction={
                  isString(childItem.link)
                    ? EventActions.NAVIGATION_LINK_CLICK
                    : EventActions.NAVIGATION_CLICK
                }
                onClick={() => {
                  this.handleLogin(childItem.id);
                }}
                role="listitem"
              />
            ))}
          </div>
        ) : null}
      </Fragment>
    );
  }
}
